import { type UseQueryResult, useQuery } from 'react-query';
import { TransferAgentCompanyService } from '../../services/wealthlane-customer-services';

const useGetTransferAgentCompanies = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>
): UseQueryResult<
  | Array<{
      label: string | null | undefined;
      value: string | undefined;
    }>
  | undefined,
  unknown
> => {
  const transferAgentOptions = useQuery(
    ['getTransferAgentOptions'],
    async () => {
      return await handleRequest(
        TransferAgentCompanyService.getApiCustomerApiAppTransferAgentCompanyTransferAgentManagedCompanies()
      );
    },
    {
      select(data) {
        return data?.map((item) => {
          return {
            label: item.companyName,
            value: item.id,
          };
        });
      },
    }
  );

  return transferAgentOptions;
};

export default useGetTransferAgentCompanies;
